
import { Component } from '@angular/core';
import { TitleBarComponent } from '../../shared/title-bar/title-bar.component';
import { FormGroup } from '@angular/forms';
import { TwoFactorAuthenticationRegistrationFormType } from '../two-factor-authentication-registration-form-type';
import { TwoFactorAuthenticationRegistrationService } from '../two-factor-authentication-registration.service';
import { IRequest2FARegistrationCodeResponseDTO, Request2FARegistrationCodeDTO, Request2FARegistrationCodeResponseDTO, RequestSelfReset2FARegistrationDTO, Verify2FARegistrationCodeDTO } from '../../models/models.swagger.generated';
import { twoFactorAuthenticationRegistrationRoute } from 'src/app/core/routing/route-names';
import { StepperAllModule, StepperModule } from '@syncfusion/ej2-angular-navigations';
import { IStepAuthenticateData, StepAuthenticateComponent } from '../steps/step-authenticate/step-authenticate.component';
import { StepQrcodeComponent } from '../steps/step-qrcode/step-qrcode.component';
import { StepVerifyRegistrationComponent, ValidateFormType } from '../steps/step-verify-registration/step-verify-registration.component';
import { StepRegistrationSuccessfulComponent } from '../steps/step-registration-successful/step-registration-successful.component';
import { StepVerifyRecoveryCodeComponent, VerifyRecoveryCodeFormType } from '../steps/step-verify-recovery-code/step-verify-recovery-code.component';

@Component({
    selector: 'app-two-factor-authentication-recovery',
    templateUrl: './two-factor-authentication-recovery.component.html',
    styleUrls: ['./two-factor-authentication-recovery.component.scss'],
    imports: [TitleBarComponent, StepperAllModule, StepperModule, StepAuthenticateComponent, StepVerifyRecoveryCodeComponent, StepQrcodeComponent, StepVerifyRegistrationComponent, StepRegistrationSuccessfulComponent]
})
export class TwoFactorAuthenticationRecoveryComponent {
  public loading = false;
  public qrData: IRequest2FARegistrationCodeResponseDTO;
  public stepIndex = 0;
  public stepAuthenticateData: IStepAuthenticateData = {
    header: 'i18n.base.two-factor-authentication.recovery.step1-header',
    description: 'i18n.base.two-factor-authentication.recovery.step1-description',
    linkLabel: 'i18n.base.two-factor-authentication.recovery.register-2FA',
    linkRoute: twoFactorAuthenticationRegistrationRoute,
    buttonText: 'i18n.base.two-factor-authentication.recovery.get-code'
  };

  private form: FormGroup<TwoFactorAuthenticationRegistrationFormType>;

  constructor(
    private service: TwoFactorAuthenticationRegistrationService
  ) { }

  public requestRecoveryCode(form: FormGroup<TwoFactorAuthenticationRegistrationFormType>): void {
    if (form.invalid || this.loading) {
      return;
    }
    var request = new RequestSelfReset2FARegistrationDTO({userName: form.value.userName, password: form.value.password});
    this.form = form;
    this.service.requestRecovery(request).subscribe({
      next: () => {
        this.loading = false;
        this.stepIndex = 1;
      },
      error: () => {
        this.loading = false;
      }
    });
  }

  public requestQrCode(verifyForm: FormGroup<VerifyRecoveryCodeFormType>): void {
    if (this.form.invalid || verifyForm.invalid ||  this.loading) {
      return;
    }
    var request = new Request2FARegistrationCodeDTO({userName: this.form.value.userName, password: this.form.value.password, recoveryCode: verifyForm.value.recoveryCode});
    this.service.requestCode(request).subscribe({
      next: (response: Request2FARegistrationCodeResponseDTO) => {
        this.qrData = response;
        this.loading = false;
        this.stepIndex = 2;
      },
      error: () => {
        this.loading = false;
      }
    });
  }

  public onQrCodeRegistered(): void {
    this.stepIndex = 3;
  }

  public validateRegistration(validateForm: FormGroup<ValidateFormType>): void {
    if (this.form.invalid || validateForm.invalid || this.loading) {
      return;
    }
    this.service.verifyRegistration(new Verify2FARegistrationCodeDTO({userName: this.form.value.userName, password: this.form.value.password, code: validateForm.value.token})).subscribe({
      next: () => {
        this.loading = false;
        this.stepIndex = 4;
      },
      error: () => {
        this.loading = false;
      }
    });
  }
}
